function loadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/util/nice/${view}.vue`
    );
}

const niceRoutes = [
  /* nive 본인인증 */

  // 휴대폰번호 가져오기
  {
    path: '/phone-number/result',
    name: 'getUserPhoneNumber',
    component: loadView('getUserPhoneNumber'),
  },

  // 휴대폰번호 변경
  {
    path: '/phone-number-update',
    name: 'updateUserPhoneNumber',
    component: loadView('updateUserPhoneNumber'),
  },

  // 로그인 정보 가져오기
  {
    path: '/get-info',
    name: 'getUserInfo',
    component: loadView('getUserInfo'),
  },

  // 회원 탈퇴
  {
    path: '/withdrawal-check/result',
    name: 'withdrawMember',
    component: loadView('withdrawMember'),
  },
];

export default niceRoutes;
